// src/components/Projects.js
import React from "react";

function Projects() {
  const projects = [
    {
      title: "Yoga Assistant",
      type: "Deep Learning",
      summary:
        "AI-powered yoga posture recognition system using computer vision to provide real-time feedback and guidance.",
      links: {
        doc: "/docs/yoga-assistant.pdf",
        github: "https://github.com/PSURI1894/yoga_assisstant",
      },
    },
    {
      title: "Heart Disease Predictor",
      type: "AI-ML",
      summary:
        "Predicts the likelihood of heart disease using key clinical features and supervised machine learning models.",
      links: {
        doc: "/docs/heart-disease-predictor.pdf",
        github: "https://github.com/PSURI1894/heart-disease-predictor",
      },
    },
    {
      title: "Credit Project",
      type: "AI/ML",
      summary:
        "A predictive credit scoring model leveraging historical loan and behavioral data for risk evaluation.",
      links: {
        doc: "/docs/credit-project.pdf",
        github: "https://github.com/PSURI1894/Credit_Project",
      },
    },
    {
      title:
        "AI-Based Detection and Quantification of Pulmonary Nodules (Advanced)",
      type: "Deep Learning",
      summary:
        "Deep learning model for detecting and quantifying pulmonary nodules in CT scans using CNNs and segmentation.",
      links: {
        doc: "/docs/pulmonary-nodules-advanced.pdf",
        github:
          "https://github.com/PSURI1894/HDA-VIT",
      },
    },
    {
      title: "Telecom Churn Prediction",
      type: "Data Science",
      summary:
        "Predictive analytics project to identify customer churn using classification models and feature importance.",
      links: {
        deploy: "https://telcochurnprediction-dpnmsgt9en5fhbpfywtu2n.streamlit.app/",
        github: "https://github.com/PSURI1894/telco_churn_prediction",
      },
    },
    {
      title: "Credit Risk Assessment",
      type: "Data Science",
      summary:
        "ML-based risk model to assess customer creditworthiness for banking and financial institutions.",
      links: {
        deploy: "https://6ttlzjprygaiokv9trfcgu.streamlit.app/",
        github: "https://github.com/PSURI1894/credit_risk_assesment_project",
      },
    },
    {
      title: "Retail Finance",
      type: "Quant Research",
      summary:
        "Data-driven retail finance forecasting model combining econometric and statistical ML approaches.",
      links: {
        deploy: "https://parthsuri.shinyapps.io/retail_finance_project/",
        github: "https://github.com/PSURI1894/retail_finance_project",
      },
    },
    {
      title: "Fake News Detection",
      type: "NLP",
      summary:
        "NLP-based fake news classifier using TF-IDF vectorization and logistic regression to detect misinformation.",
      links: {
        deploy: "https://fakenews-aibthcq9jht9v2zfannvta.streamlit.app/",
        github: "https://github.com/PSURI1894/fake_news",
      },
    },
    {
      title: "Cinema Match",
      type: "Data Science",
      summary:
        "Movie recommendation system powered by content-based filtering and similarity metrics.",
      links: {
        deploy: "https://cinemamatch-bwytrlsvet9wrebtlfnvtz.streamlit.app/",
        github: "https://github.com/PSURI1894/cinema_match",
      },
    },
    {
      title: "Climate Rainfall Realtime",
      type: "API + ML",
      summary:
        "Real-time rainfall prediction using live weather API data and regression models for regional forecasting.",
      links: {
        github:
          "https://github.com/PSURI1894/climate_rainfall_realtime",
      },
    },
    {
      title: "Stock Sentiment Analysis",
      type: "API + Quant",
      summary:
        "Analyzes stock market sentiment using Twitter and financial news APIs to correlate with market trends.",
      links: {
        github:
          "https://github.com/PSURI1894/stock_sentiment_realtime",
      },
    },
    {
      title: "Ecom Sales Dashboard",
      type: "Data Science + Quant",
      summary:
        "Interactive dashboard analyzing e-commerce sales trends and performance metrics using Python and Plotly.",
      links: {
        github: "https://github.com/PSURI1894/ecom_sales_dashboard",
      },
    },
    {
      title: "Zomato Analysis",
      type: "Data Science + Quant",
      summary:
        "Comprehensive data analysis on Zomato restaurants including ratings, cost, and location-based insights.",
      links: {
        deploy: "https://zomatoanalysisbyps.streamlit.app/",
        github: "https://github.com/PSURI1894/zomato_analysis",
      },
    },
    {
      title: "Supply Chain Dashboard",
      type: "Data Science + Quant",
      summary:
        "Optimized supply chain dashboard visualizing KPIs like logistics cost, lead time, and performance efficiency.",
      links: {
        github:
          "https://github.com/PSURI1894/supply_chain_dashboard",
      },
    },
    {
      title: "ML-Flow",
      type: "ML + DevOps",
      summary:
        "Machine learning workflow automation integrating experiment tracking and model versioning with MLflow.",
      links: {
        github: "https://github.com/PSURI1894/mlflow",
      },
    },
    {
      title: "Fraud Detection",
      type: "FastAPI + ML",
      summary:
        "Deployed ML model via FastAPI to detect fraudulent transactions with real-time scoring API.",
      links: {
        github: "https://github.com/PSURI1894/fraud-detection-fastapi",
      },
    },
    {
      title: "ML-OPS",
      type: "ML + CI/CD Pipelines",
      summary:
        "End-to-end ML pipeline integrating CI/CD automation using GitHub Actions and Dockerized workflows.",
      links: {
        github: "https://github.com/PSURI1894/ml_ops_cicd",
      },
    },
    {
      title: "Fly-High Ticket Booking App",
      type: "MERN Full-Stack",
      summary:
        "A ticket booking app made using the MERN Stack application which shows the phases in booking a ticket.",
      links: {
        github:
          "https://github.com/your-github-username/aws-sagemaker-shape-detection",
      },
    },
  ];

  return (
    <div className="section-content projects-section">
      <h1>Projects</h1>
      <p className="section-intro">
        A collection of professional and academic projects in AI, ML, Deep
        Learning, and Quantitative Research. Each project represents a fusion of
        technical skill and problem-solving.
      </p>

      <div className="projects-grid">
        {projects.map((project) => (
          <div className="project-card" key={project.title}>
            <h3 className="project-title">{project.title}</h3>
            <p className="project-type">{project.type}</p>
            <p className="project-summary">{project.summary}</p>

            <div className="project-links">
              {project.links.github && (
                <a
                  className="btn secondary"
                  href={project.links.github}
                  target="_blank"
                  rel="noreferrer"
                >
                  GitHub
                </a>
              )}
              {project.links.doc && (
                <a
                  className="btn secondary"
                  href={project.links.doc}
                  target="_blank"
                  rel="noreferrer"
                >
                  Docs
                </a>
              )}
              {project.links.deploy && (
                <a
                  className="btn secondary"
                  href={project.links.deploy}
                  target="_blank"
                  rel="noreferrer"
                >
                  Live
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
